<script setup>
import { computed } from 'vue';
import { TabsProvider } from './useTabs';

const props = defineProps({
  value: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['input', 'change']);

function onChange(value) {
  emit('input', value);
  emit('change', value);
}

TabsProvider({
  rootValue: computed(() => props.value),
  onChange,
});
</script>

<template>
  <div class="flex gap-1" data-component="CsTabs">
    <slot />
  </div>
</template>
